<template>
  <b-nav-item-dropdown menu-class="p-1 grid-dropdown" right toggle-class="pl-0" no-caret>

    <template #button-content>
      <AppSvgIcon :icon="buttonIcon" height="30" :tooltip="$t(buttonText) | capitalize"></AppSvgIcon>
      <span class="nav-menu">{{$t(buttonText) | capitalize}}</span>
      <i class="fa fa-angle-down font-weight-bold float-right ml-auto"></i>
    </template>

    <div class="bg-composed-wrapper bg-gradient-primary">
      <div class="bg-composed-wrapper--image bg-composed-img-5"></div>
      <div class="bg-composed-wrapper--content text-light text-left py-3 px-3">
        <h6 class="mb-1 text-center text-capitalize">Administration</h6>
      </div>
    </div>

    <div class="grid-menu grid-menu-3col">
      <div class="no-gutters row">
        <template v-for="item in this.items">

          <b-dropdown-item-button
            v-if="(item.roles && hasRole(item.roles)) ||
              (item.permissions && hasAnyOfPermissions(item.permissions)) ||
              (!item.roles && !item.permissions)"
            @click="$router.push({name: item.url})"
            class="col-md-6 col-lg-4"
            button-class="btn border-0 w-100 p-2 btn-outline-light text-center"
          >
            <AppSvgIcon class="font-size-xxl d-block mb-2 mx-auto" :icon="item.icon" height="30" :tooltip="$t(item.name) | capitalize"/>
            <span class="text-dark">{{$t(item.name) | capitalize}}</span>
          </b-dropdown-item-button>

        </template>
      </div>
    </div>

  </b-nav-item-dropdown>
</template>

<script>
  export default {
    name: "AppGridDropdown",
    props: {
      buttonIcon: {
        type: String,
        required: true
      },
      buttonText: {
        type: String,
        required: true
      },
      items: null
    }
  }
</script>

<style scoped>

</style>
